<template>
    <section class="providerSection">
        <NavBar />
    </section>
</template>

<script>
import NavBar from '../Navbar.vue'
export default {
    components: {
        NavBar
    }
}
</script>

<style scoped>
section {
  width: 100%;
  height: 100%;
  background-image: url("./../../assets/dashboardBG.webp");
  background-size: cover;
  background-position: center;
}
</style>
